export function formatMoney(value, currency = 'USD') {
  if (value == null) return '-';

  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency,
  }).format(value);
}

export function formatDate(date) {
  if (!date) return '-';
  return new Date(date).toLocaleDateString();
}
